import { useCallback, useContext } from 'react';
import { MenuOptionLabel } from '~/constants/srp/MenuOption';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useFacetData } from '~/context/srp/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import Label from './Label';
import { CommonWrapper } from './styles';
import useExpand from './useExpand';
import type WithClassName from './WithClassName';
import WithExpandOnOpen from './WithExpandOnOpen';

const generateId = (name: string) => name.replace(/\s/g, '').toLowerCase();

type LabelProps = {
  displayName: string;
};

const BodyTypeLabel = ({ displayName }: LabelProps) => (
  <div className="flex items-center justify-between py-2">
    <Label displayName={displayName} />
    <img
      src={`${
        process.env.CVNA_APP_ASSETS_CDN
      }/search-assets/body-types/${displayName.toLowerCase()}.png?width=93`}
      alt={displayName}
    />
  </div>
);

type OwnProps = WithClassName & WithExpandOnOpen;

export default function BodyType({ className, expandOnOpen }: OwnProps) {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const facetData = useFacetData();
  const expandSection = expandOnOpen === MenuOptionLabel.BodyType;
  const [show, setShow] = useExpand(expandSection);

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-body-style"
      facetContent={facetData.bodyStyles?.buckets}
      facetName="Body Type"
      show={show}
      onToggle={useCallback(() => setShow(v => !v), [setShow])}
      expandOnOpen={expandSection}
    >
      <CommonWrapper>
        {facetData.bodyStyles?.buckets.map(({ displayName, key }) => (
          <Checkbox
            checked={Boolean(appliedFilters.bodyStyles?.includes(key))}
            className="w-full"
            facet="bodyStyle"
            filter={displayName}
            id={`body-type-${generateId(displayName)}`}
            key={displayName}
            label={<BodyTypeLabel displayName={displayName} />}
            onChange={() =>
              updateListFilter({
                filterKey: 'bodyStyles',
                value: key
              })
            }
          />
        ))}
      </CommonWrapper>
    </FilterDrawer>
  );
}
